
// 首頁頁籤切換效果
$(document).ready(function () {
    $(".item-menu a").click(function (event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".item-content").not(tab).css("display", "none");
        $(tab).show();
    });
});


$(document).ready(function () {
  // 向上隱藏
  $('.nav-heading').click(function(){
    if ($(this).hasClass('active')){
      $(this).removeClass('active');
      // 選取的效果要消失
      $(this).next().find("li").removeClass('active');
      // 僅選擇 class 沒有 li_active 的進行slide up
      $(this).next().find("li:not(.li_slideup_ignore)").slideUp("slow")

      // 向下展示
    } else {
      console.log("下展示")
      // 其他選單向上隱藏, 選取的效果要消失 僅保留有li_slideup_ignore
      $(".nav-heading").removeClass("active");
      $(".nav-submenu li").removeClass('active');
      $(".nav-submenu li:not(.li_slideup_ignore)").slideUp('slow');


      $(this).addClass('active');
      $(this).next().find("li.li_slideup_ignore").addClass("active");
      $(this).next().find("li").slideDown('slow');
    }
  });
});


// go top
$(document).ready(function() {
    // Show or hide the sticky footer button
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('.go-top').fadeIn(200);
        } else {
            $('.go-top').fadeOut(200);
        }
    });

    // Animate the scroll to top
    $('.go-top').click(function(event) {
        event.preventDefault();

        $('html, body').animate({scrollTop: 0}, 300);
    })
});
